import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import SIgnUp from "./pages/SIgnUp";
// eslint-disable-next-line no-unused-vars
import SignIn from "./pages/SignIn";
import Notifications from "./pages/Notifications";
import Protected from "./components/Protected";
import Logout from "./pages/Logout";
import ForgotPassword from "./pages/ForgotPassword";

import SettingRoutes from "./Routes/SettingRoutes";
import AdminManagerRoutes from "./Routes/AdminManagerRoutes";
import CaAdminRoutes from "./Routes/CaAdminRoutes";
import SetPassword from "./pages/SetPassword";
import VerifyUser from "./pages/VerifyUser";
// import EditDate from "./components/legacyComp/tetsing/DateTester";
// import TableEdit from "./components/legacyComp/tetsing/tableROwedit";
// import DateTester from "./components/legacyComp/tetsing/DateTester";
import PrivacyAgreement from "./pages/PrivacyAgreement";
import NotFoundPage from "./pages/NotFoundPage";
// import NetworkStatus from "./pages/WithOfflineMessage";
import ServiceAgreement from "./pages/ServiceAggrement";
import TermsService from "./pages/TermsService";

import PasswordResetLogged from "./pages/PasswordResetLogged";
import GetAToken from "./pages/GetAToken";
import MicrosoftLoginFailed from "./pages/MicrosoftLoginFailed";
// eslint-disable-next-line no-unused-vars
import Oldsignin from "./pages/SignInOld";
// eslint-disable-next-line no-unused-vars
import CustomerRoutes from "./Routes/CustomerRoutes";
import LocationSignIn from "./pages/LocationSignIn";
import SessionExpired from "./pages/SessionExpired";
// import SessionSignIn from "./pages/SessionSignIn";
import Help from "./pages/Help";
import ActivateUser from "./pages/ActivateUser";
// eslint-disable-next-line no-unused-vars

import UserRoutes from "./Routes/UserRoleRoutes";
import TraineryLearnRoutes from "./Routes/TraineryLearnRoutes";
import ZohoFormIframe from "./pages/ZohoForm/ZohoFormIframe";
import FormSuccessClose from "./pages/ZohoForm/FormSuccessClose";
import DynamicRoutes from "./Routes/DynamicRoutes";
import { LearningPathJourney } from "./components/legacyComp/tetsing/TimelineTester";
// import ScormPreviewTest from "./components/legacyComp/tetsing/ScormPreviewTest";
// import ScormPreviewTest2 from "./components/legacyComp/tetsing/ScormPreviewTest2";
// import ScormTest3 from "./components/legacyComp/tetsing/ScormTest3";
// import CertificateEditor from "./components/legacyComp/tetsing/CertificateEditor";
// import ScrollableCourseCards from "./components/legacyComp/tetsing/ScrollableCourseCards";
// import NewDashBoard from "./components/legacyComp/tetsing/NewDashBoard";
// import CourseLearningPlan from "./pages/Admin-pages/CAAdminCoursePages/Records/CourseLearningPlan";
// import NewSideBarTest from "./components/legacyComp/tetsing/NewSideBarTest";

function App() {
  return (
    <>
      <Router>
        {/* <NetworkStatus /> */}
        <Routes>
          <Route exact path="/" element={<SignIn />} />

          <Route
            exact
            path="/location-otp-verification"
            element={<LocationSignIn />}
          />
          {/* <Route
            exact
            path="/session-otp-verification"
            element={<SessionSignIn />}
          /> */}
          <Route exact path="/help" element={<Help />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route
            exact
            path="/session-expiry-logout"
            element={<SessionExpired />}
          />
          <Route
            exact
            path="/trainery-ms-login-failed"
            element={<MicrosoftLoginFailed />}
          />
          <Route exact path="/getAToken" element={<GetAToken />} />
          <Route exact path="*" element={<NotFoundPage />} />
          <Route
            exact
            path="/setpassword/:uid/:token"
            element={<SetPassword />}
          />
          <Route
            exact
            path="/verification/:uid/:token"
            element={<VerifyUser />}
          />
          <Route
            exact
            path="/activation/:uid/:token"
            element={<ActivateUser />}
          />
          <Route
            exact
            path="/logout"
            element={
              <Protected>
                <Logout />
              </Protected>
            }
          />
          <Route
            exact
            path="/home"
            element={
              <Protected>
                <Notifications />
              </Protected>
            }
          />
          <Route path="/notifications" element={<Navigate to="/home" />} />
          <Route
            exact
            path="/privacy-agreement"
            element={
              <Protected>
                <PrivacyAgreement />
              </Protected>
            }
          />
          <Route
            exact
            path="/service-agreement"
            element={
              <Protected>
                <ServiceAgreement />
              </Protected>
            }
          />
          <Route
            exact
            path="/terms-of-service"
            element={
              <Protected>
                <TermsService />
              </Protected>
            }
          />
          <Route
            exact
            path="/logged-in-user-reset-password"
            element={
              <Protected>
                <PasswordResetLogged />
              </Protected>
            }
          />
          <Route
            path="/report"
            element={
              <Protected>
                <ZohoFormIframe />
              </Protected>
            }
          />
          <Route path="/form-submit-success" element={<FormSuccessClose />} />
          <Route path="/testing" element={<LearningPathJourney />} />
          {/* -----------------------Admin routes-------------------------------- */}
          {SettingRoutes()}
          {AdminManagerRoutes()}
          {CustomerRoutes()}
          {CaAdminRoutes()}
          {TraineryLearnRoutes()}
          {DynamicRoutes()}
          {/* -----------------------User routes-------------------------------- */}
          {UserRoutes()}
        </Routes>
      </Router>
    </>
  );
}

export default App;
